import React from 'react';
import PropTypes from 'prop-types';

export function FilterPillGroup({ options, value, onChange }) {
  return (
    <div className="onyx-filter-pills" data-testid="onyx-filter-pills" role="group">
      {options.map((opt) => {
        const active = opt.id === value;
        const withIcon = Boolean(opt.icon);
        return (
          <button
            key={opt.id}
            type="button"
            className={
              `onyx-filter-pills__pill`
              + `${withIcon ? ' onyx-filter-pills__pill--with-icon' : ''}`
              + `${active ? ' onyx-filter-pills__pill--active' : ''}`
            }
            aria-pressed={active}
            onClick={() => onChange(opt.id)}
          >
            {opt.icon === 'check' ? (
              <svg
                className="onyx-filter-pills__icon"
                width="11"
                height="11"
                viewBox="0 0 12 12"
                aria-hidden="true"
              >
                <path
                  d="M2.5 6 L5 8.5 L9.5 3.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : null}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

FilterPillGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOf(['check']),
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
